import React, {
  useContext,
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from 'react';
import { AlertColor, Box, Card, Grid, Typography } from '@mui/material';

import * as Yup from 'yup';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import MediumTypography from '../../components/formlib/MediumTypography';
import ConsentGeneralInfo from './ConsentGeneralInfo';
import SingleLine from '../../components/formlib/SingleLine';
import ConsentClientDetails, { Client } from './ConsentClientDetails';
import ConsentSignature from './ConsentSignature';
import {
  ConsentClientSignature,
  ConsentClientContact,
  ConsentDetailsType,
  downloadLeaReferral,
  getConsentDetailsLEA,
  updateConsent,
} from '../../services/configApi/forms/Consent/ConsentServices';
import { ApiError, isCustomError } from '../../services/ApiResponseHandler';
import moment from 'moment';
import ConsentGRI from './ConsentJson/Consent-GRI.json';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import dayjs from 'dayjs';
import { Formik, FormikProps } from 'formik';
import Textinput from '../../components/formlib/Textinput';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import { useNavigate, useLocation } from 'react-router';
import { FACESHEET, LEA_REFERRAL_DASHBOARD } from '../../routes/Routing';
import ProgramPanel from '../../components/forms/ProgramPanel';
import CustomRadioButton from '../../components/formlib/CustomRadioButton';
import TranslateWidget, { setLanguage } from '../../TranslateWidget';
import { UnSavedChangesContext } from '../../context/UnSavedChangesProvider';
import ModalPopup from '../../components/formlib/ModalPopup';
import LanguageSelectionDialog from '../../components/shared/LanguageSelectionDialog';
import { checkOffline } from '../../services/Offline';
import { useMultiplePermissions } from '../../hooks/usePermissions';
import {
  REFERRAL_STATUS_KEY,
  DATE_FORMAT,
  LOCAL_DATE_TIME_UTC_FORMAT,
} from '../../services/Constant';
import CheckBoxComponent from '../../components/formlib/CheckBoxComponent';
import DropdownComponent from '../../components/formlib/DropdownComponent';
import { OptionType } from '../../utils/type';
import { getClientDocumentFileName } from '../../utils/fileUtils';
export const initialStateValues: ConsentDetailsType = {
  type: '',
  name: '',
  consentId: '',
  version: 1,
  signedDate: '',
  revokedDate: '',
  status: 'Not Current',
  requestedDate: '',
  requester: {
    name: '',
    email: '',
    phone: '',
  },
  client: {
    id: '',
    name: '',
    dphId: '',
    gender: '',
    dob: '',
    address: '',
  },
  selectedContact: [],
  contact: [
    {
      id: '',
      name: '',
      address: '',
      email: '',
      phone: '',
      isGuardian: false,
      isPrimary: false,
      isLegalGuardian: false,
      type: '',
    },
  ],
  refusal: false,
  signature: [
    {
      id: '',
      name: '',
      relationship: '',
      email: '',
      signature: '',
      verbal: false,
      date: '',
      paperConsent: false,
      license: '',
      isPrimary: false,
      isLegal: false,
      isGuardian: false,
    },
  ],
  programProposes: null,
  communicationMode: null,
  purpose: null,
  programDetails: {
    name: '',
    phoneNumber: '',
    email: '',
    addressLine1: '',
    addressLine2: '',
    faxNumber: '',
    website: '',
    city: '',
    state: '',
    zipCode: '',
    imageUrl: '',
  },
  ifsp: null,
  serviceDeliveryPlan: {
    // Will be removed after geting confirmation from respective dev
    // changes: '',
    isEligibleUntilThirdBirthday: '',
    eligibleTool: {
      id: '',
      label: '',
    },
    assessmentCompletionDate: null,
    reEstablishedDate: null,
    parentInitial: { id: '', label: '' },
    isChecked: false,
    participated: false,
    agreeDisagree: '',
    exceptionList: '',
    consent: false,
  },
  eligibility: null,
  other: false,
  otherContactName: '',
  othersComment: '',
  summary: '',
  description: '',
  selectedLanguage: 'en',
  uiVersion: 1,
  dateMailed: null,
  initials: null,
  consentPwnType: {
    id: null,
    pwnType: null,
    pwnDescription: null,
  },
  consentInsurance: null,
  revokeSignature: null,
};

export const initalStates = {
  schoolName: '',
  schoolNameMandatory: true,
};

export type SchoolNameType = {
  schoolName: string;
  schoolNameMandatory: boolean;
};
const LEAReferralConsent = () => {
  const navigate = useNavigate();
  const validationSchema = Yup.object({
    schoolName: Yup.string().when('schoolNameMandatory', {
      is: true,
      then: Yup.string().required('formBuilder.Name'),
      otherwise: Yup.string().nullable(),
    }),
    schoolNameMandatory: Yup.boolean().nullable(),
  });

  const formRef = useRef<FormikProps<SchoolNameType>>(null);

  const [initialState, setInitialState] =
    useState<SchoolNameType>(initalStates);
  const [initialBackupState, setInitialBackupState] =
    useState<SchoolNameType>(initalStates);
  const [selectedClient, setSelectedClient] = useState<Client>({
    name: '',
    dob: '',
    dphId: '',
    address: '',
    gender: '',
  });
  const { toggleLoader } = useContext(LoaderContext) as LoaderContextType;
  const { handleUpdateUnsavedChanges } = useContext(UnSavedChangesContext);
  const [open, setOpen] = React.useState(false);
  const [toastrVariable, setToastrVariable] =
    React.useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [toastrId, setToastrId] = React.useState('');
  const [consentDetails, setConsentDetails] =
    useState<ConsentDetailsType>(initialStateValues);

  const [consentBackupDetails, setConsentBackupDetails] =
    useState<ConsentDetailsType>(initialStateValues);
  const [consentName] = useState('LEA');
  const [disclaimer] = useState(ConsentGRI[1].DisclaimerText);
  const [expiryDate, setExpiryDate] = useState<string>('');
  const [btnName, setBtnName] = useState<boolean>(false);
  const translationId = useRef('Consent');
  const [selectedLanguageValue, setSelectedLanguageValue] =
    useState<string>('');
  const [showAlertDialog, setShowAlertDialog] = useState<boolean>(false);
  const [openDownloadLanguageModal, setOpenDownloadLanguageModal] =
    useState<boolean>(false);
  const [isOffline, setIsOffline] = React.useState(false);
  const [enableDownload, setEnableDownload] = React.useState(false);
  const [checked, setChecked] = useState(false);
  const [revokeGuardian, setRevokeGuardian] = useState<OptionType | null>(null);
  const [guardianContacts, setGuardianContacts] = useState<OptionType[]>([]);
  const [contactSelected, setContactSelected] = useState<OptionType | null>(
    null,
  );
  const permissions = useMultiplePermissions([
    'backend.clients',
    'backend.in_active_referrals',
  ]);
  const referralStatus = localStorage.getItem(REFERRAL_STATUS_KEY) ?? 'None';
  const isAuthorized =
    referralStatus === 'Inactive'
      ? permissions['backend.clients'].canEdit &&
        permissions['backend.in_active_referrals'].canEdit
      : (permissions['backend.clients'].canEdit ||
          permissions['backend.in_active_referrals'].canEdit) &&
        !(selectedLanguageValue !== '' && selectedLanguageValue !== 'en');

  const [hasEditPermission, setHasEditPermission] = useState<boolean>(false);
  const location = useLocation();
  const consentIdCheck = location?.state?.LEA
    ? location.state.LEA.consentId || ''
    : '';

  useEffect(() => {
    if (!hasEditPermission && isAuthorized) {
      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === 'Tab') {
          e.preventDefault();
        }
      };
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [hasEditPermission, isAuthorized]);

  const getDateFormatedValue = (locationDate: string | Date | null) => {
    let originalDate: string;
    if (locationDate === '' || locationDate === null) {
      const currentUtcDate = new Date();
      currentUtcDate.setUTCFullYear(currentUtcDate.getUTCFullYear() + 1);

      originalDate = currentUtcDate.toISOString();
    } else {
      const currentUtcDate = new Date(locationDate);
      currentUtcDate.setUTCFullYear(currentUtcDate.getUTCFullYear() + 1);

      originalDate = currentUtcDate.toISOString();
    }

    return originalDate;
  };

  useLayoutEffect(() => {
    const getOfflineMode = async () => {
      const offlineFlag = await checkOffline();
      setIsOffline(offlineFlag);
    };
    getOfflineMode();
  });
  const getStatusCheck = (status?: string) => {
    if (!status) {
      return 'Not Current';
    }

    if (status === 'Revoked') {
      return 'Revoked';
    }

    return status;
  };
  const getLEAReferral = (consentId: string = '') => {
    getConsentDetailsLEA('LEA', consentId)
      .then(async (response) => {
        toggleLoader(false);
        if (response) {
          if (response.signature.length == 0) {
            response.signature = [
              {
                id: '',
                name: '',
                relationship: '',
                email: '',
                signature: '',
                date: '',
                rowKey: '',
                verbal: false,
                paperConsent: false,
                firstName: '',
                lastName: '',
                isLegal: false,
                isPrimary: false,
                isGuardian: false,
              },
            ];
          }

          if (
            response.consentId !== null &&
            response.consentId !== undefined &&
            response.consentId !== ''
          ) {
            setEnableDownload(true);
          }
          formRef.current?.setValues((prevValues) => ({
            ...prevValues,
            schoolName: response.description,
            schoolNameMandatory:
              response.schoolNameMandatory !== undefined &&
              response.schoolNameMandatory,
          }));
          setInitialState((prevValues) => ({
            ...prevValues,
            schoolName: response.description,
            schoolNameMandatory:
              response.schoolNameMandatory !== undefined &&
              response.schoolNameMandatory,
          }));
          setInitialBackupState((prevValues) => ({
            ...prevValues,
            schoolName: response.description,
            schoolNameMandatory:
              response.schoolNameMandatory !== undefined &&
              response.schoolNameMandatory,
          }));
          setConsentDetails(response);
          setConsentBackupDetails(response);
          setLanguage(response.selectedLanguage);
          const resultExpiry =
            response.type === 'NoticeOfPrivacyPractices' ||
            response.type === 'LegalReleaseofRecords' ||
            response.type === 'PriorWrittenNoticeForm' ||
            response.type === 'ConsentForChangeServiceDeliveryPlan'
              ? ''
              : getDateFormatedValue(response.signedDate);
          setExpiryDate(resultExpiry);
          setSelectedClient({
            name: response.client.name,
            dob: response.client.dob,
            dphId: response.client.dphId ?? '',
            address: response.client.address ?? '',
            gender: response.client.gender,
          });
          const statusCheck = getStatusCheck(response.status);

          if (statusCheck === 'Revoked') {
            setHasEditPermission(false);
          } else if (response.signature.length > 0) {
            if (
              response.signature[0].rowKey ||
              response.signature[0].verbal ||
              response.signature[0].paperConsent
            ) {
              setHasEditPermission(false);
            } else {
              setHasEditPermission(true);
            }
          } else if (response.signature.length === 0) {
            setHasEditPermission(true);
          }
          if (response.signature.length > 0) {
            if (
              response.signature[0].id === '' &&
              response.signature[0].name === ''
            ) {
              setContactSelected(null);
            } else {
              setContactSelected({
                id: response.signature[0].id,
                label: response.signature[0].name,
              });
            }
          }
          setChecked(response.refusal);
          if (response.revokeSignature) {
            setRevokeGuardian({
              id: response.revokeSignature.id,
              label: response.revokeSignature.name,
            });
          } else {
            setRevokeGuardian(null);
          }
          await getContacts(response.contact);
        }
      })
      .catch(async (error) => {
        toggleLoader(false);
        setOpen(true);
        setToastrVariable('error');
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrId('internetCheckConnectionError');
          setToastrDefaultMessage('internetCheckConnectionError');
        }
      });
  };

  useEffect(() => {
    toggleLoader(true);
    getLEAReferral(consentIdCheck);
  }, []);

  const handleStatus = (statusValue: string) => {
    let validatedStatus = '';
    if (statusValue.toLowerCase().includes('revoked')) {
      validatedStatus = 'Revoked'.concat(
        ' (' +
          moment(dayjs(consentDetails.revokedDate).toDate()).format(
            'MM/DD/YYYY',
          ) +
          ')',
      );
    } else {
      validatedStatus = statusValue;
    }

    return validatedStatus;
  };

  const handleClear = () => {
    if (
      JSON.stringify(consentBackupDetails) === JSON.stringify(consentDetails) &&
      JSON.stringify(initialState) === JSON.stringify(initialBackupState)
    ) {
      navigate(FACESHEET);
    } else {
      setShowAlertDialog(true);
    }
  };

  useEffect(() => {
    if (
      JSON.stringify(consentBackupDetails) === JSON.stringify(consentDetails) &&
      JSON.stringify(initialState) === JSON.stringify(initialBackupState)
    ) {
      handleUpdateUnsavedChanges(false);
    } else {
      handleUpdateUnsavedChanges(true);
    }
    getContacts(consentDetails.contact);
  }, [consentDetails, consentBackupDetails, initialState, initialBackupState]);

  const onSaveClick = (sign: string, id: number) => {
    const signatureDate = moment().format('MM/DD/YYYY');
    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map(
        (item, index) => {
          if (index === id) {
            return {
              ...item,
              signature: sign,
              date: signatureDate,
              partitionKey: '',
              rowKey: '',
            };
          }
          return item;
        },
      );

      return {
        ...prevConsentDetails,
        signature: updatedSignature,
      };
    });
  };

  const onVerbalConsentClick = (value: boolean, index: number) => {
    const signatureDate = moment().format('MM/DD/YYYY');
    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map((item, id) => {
        if (id === index) {
          return {
            ...item,
            verbal: value,
            date: signatureDate,
          };
        }
        return item;
      });

      return {
        ...prevConsentDetails,
        signature: updatedSignature,
      };
    });
  };

  const onPaperConsentClick = (value: boolean, index: number) => {
    const signatureDate = moment().format('MM/DD/YYYY');
    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map((item, id) => {
        if (id === index) {
          return {
            ...item,
            paperConsent: value,
            date: signatureDate,
          };
        }
        return item;
      });

      return {
        ...prevConsentDetails,
        signature: updatedSignature,
      };
    });
  };

  const handleSave = () => {
    if (
      (consentDetails.signature[0].rowKey ||
        consentDetails.signature[0].signature ||
        consentDetails.signature[0].verbal ||
        consentDetails.signature[0].paperConsent) &&
      (!consentDetails.signature[0].consentSignedDate ||
        !dayjs(consentDetails.signature[0].consentSignedDate).isValid())
    ) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Consent date is Required');
      setToastrId('ConsentForms.consentDateIsRequired');
      return;
    }
    if (consentDetails.refusal && !revokeGuardian) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Revoking consent require guardian signature');
      setToastrId('revokeGuardianNameRequired');
      return;
    }

    if (consentDetails.refusal && consentDetails.revokeSignature) {
      const signature = consentDetails.revokeSignature;
      if (
        ((consentDetails.uiVersion != null &&
          consentDetails.uiVersion <= 2 &&
          !signature.verbal) ||
          (consentDetails.uiVersion != null &&
            consentDetails.uiVersion > 2 &&
            !signature.paperConsent)) &&
        signature.signature === '' &&
        !signature.rowKey
      ) {
        setOpen(true);
        setToastrVariable('error');
        setToastrDefaultMessage('Revoking consent require guardian signature');
        setToastrId('revokeGuardianNameRequired');
        return;
      }
    }

    if (
      consentDetails.refusal &&
      dayjs(consentDetails.revokedDate).isBefore(
        dayjs(consentDetails.signedDate).format(DATE_FORMAT),
      )
    ) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Refusal Date cannot be before Consent Date');
      setToastrId('ConsentForms.refusalDateCannotBeBeforeToday');
      return;
    }
    if (consentDetails.refusal && !consentDetails.revokedDate) {
      setOpen(true);
      setToastrVariable('error');
      setToastrDefaultMessage('Revoke Date is required for Consent form');
      setToastrId('ConsentForms.revokeDateRequired');
      return;
    }
    toggleLoader(true);
    if (consentDetails.signature.length > 0) {
      const resultStatus =
        consentDetails.refusal ||
        consentDetails.signature.some(
          (s) =>
            s.signature !== '' || s.verbal || s.paperConsent || s.rowKey !== '',
        );
      const updatedSignature = consentDetails.signature.map((item) => {
        return {
          ...item,
          date: moment(new Date(), 'MM/DD/YYYY HH:mm:ss')
            .utc()
            .format('YYYY-MM-DDTHH:mm:ss'),
        };
      });
      let revokedDateValue = '';

      if (consentDetails.refusal) {
        revokedDateValue = consentDetails.revokedDate
          ? dayjs(consentDetails.revokedDate, DATE_FORMAT)
              .hour(dayjs().hour())
              .minute(dayjs().minute())
              .second(dayjs().second())
              .millisecond(dayjs().millisecond())
              .toISOString()
          : '';
      }

      const resultSigned =
        consentDetails.signedDate === ''
          ? new Date().toISOString()
          : consentDetails.signedDate;
      let signedDateVal: string | Date = '';
      if (
        consentDetails.signature.length > 0 &&
        consentDetails.signature.some(
          (item) =>
            item.signature !== '' ||
            item.verbal ||
            item.paperConsent ||
            item.rowKey !== '',
        )
      ) {
        consentDetails.signature.forEach((item) => {
          if (
            item.signature !== '' ||
            item.verbal ||
            item.paperConsent ||
            item.rowKey !== ''
          ) {
            signedDateVal =
              dayjs(consentDetails.signature[0].consentSignedDate, DATE_FORMAT)
                .hour(dayjs().hour())
                .minute(dayjs().minute())
                .second(dayjs().second())
                .millisecond(dayjs().millisecond())
                .toISOString() ?? '';
          }
        });
      }

      if (resultStatus) {
        const params: ConsentDetailsType = {
          source: 'lea',
          type: consentDetails.type,
          name: consentName,
          consentId: consentDetails.consentId,
          version: 1,
          signedDate: signedDateVal,
          revokedDate: revokedDateValue,
          status: consentDetails.status,
          requestedDate: consentDetails.requestedDate,
          requester: {
            name: consentDetails.requester.name,
            email: consentDetails.requester.email,
            phone: consentDetails.requester.phone,
          },
          client: {
            id: consentDetails.client.id,
            name: consentDetails.client.name,
            dphId: consentDetails.client.dphId,
            gender: consentDetails.client.gender,
            dob: consentDetails.client.dob,
            address: consentDetails.client.address,
          },
          selectedContact: [],
          contact: consentDetails.contact,
          refusal: consentDetails.refusal,
          signature: updatedSignature,
          programProposes: consentDetails.programProposes,
          communicationMode: consentDetails.communicationMode,
          purpose: consentDetails.purpose,
          programDetails: consentDetails.programDetails,
          ifsp: consentDetails.ifsp,
          serviceDeliveryPlan: {
            agreeDisagree: consentDetails.serviceDeliveryPlan.agreeDisagree,
            assessmentCompletionDate:
              consentDetails.serviceDeliveryPlan.assessmentCompletionDate ===
                '' || null
                ? dayjs().format('MM/DD/YYYY')
                : consentDetails.serviceDeliveryPlan.assessmentCompletionDate,
            // Will be removed after geting confirmation from respective dev
            // changes: consentDetails.serviceDeliveryPlan.changes,
            consent: consentDetails.serviceDeliveryPlan.consent,
            eligibleTool: consentDetails.serviceDeliveryPlan.eligibleTool,
            exceptionList: consentDetails.serviceDeliveryPlan.exceptionList,
            isChecked: consentDetails.serviceDeliveryPlan.isChecked,
            isEligibleUntilThirdBirthday:
              consentDetails.serviceDeliveryPlan.isEligibleUntilThirdBirthday,
            parentInitial: consentDetails.serviceDeliveryPlan.parentInitial,
            participated: consentDetails.serviceDeliveryPlan.participated,
            reEstablishedDate:
              consentDetails.serviceDeliveryPlan.reEstablishedDate === '' ||
              null
                ? dayjs().format('MM/DD/YYYY')
                : consentDetails.serviceDeliveryPlan.reEstablishedDate,
          },
          eligibility: consentDetails.eligibility,
          other: consentDetails.other,
          othersComment: consentDetails.othersComment,
          otherContactName: consentDetails.otherContactName,
          summary: consentDetails.summary,
          description: initialState.schoolName,
          schoolNameMandatory: initialState.schoolNameMandatory,
          selectedLanguage: selectedLanguageValue,
          uiVersion: consentDetails.uiVersion,
          dateMailed: consentDetails.dateMailed,
          initials: consentDetails.initials,
          consentPwnType: consentDetails.consentPwnType,
          consentInsurance: consentDetails.consentInsurance,
          revokeSignature: consentDetails.revokeSignature,
        };
        setConsentDetails((preValues) => {
          return {
            ...preValues,
            signedDate: resultSigned,
          };
        });
        setConsentBackupDetails(consentDetails);
        setInitialBackupState(initialState);
        updateConsent(
          consentDetails.type,
          consentDetails.consentId,
          params,
          null,
        )
          .then((response) => {
            if (response) {
              setOpen(true);
              setToastrVariable('success');
              setToastrId('ConsentForms.submitToaster');
              setToastrDefaultMessage('Consent Form Successfully Saved.');
              setBtnName(true);
              // Need to work on this once the api is ready
              // getLEAReferral(consentIdCheck);
              // Need to work on this once the api is ready

              setTimeout(() => {
                toggleLoader(false);
                navigate(LEA_REFERRAL_DASHBOARD);
              }, 1000);
            }
          })
          .catch((error) => {
            setOpen(true);
            toggleLoader(false);
            setToastrVariable('error');
            if (isCustomError(error)) {
              const apiError = error as ApiError;
              setToastrId(apiError.id);
              setToastrDefaultMessage(apiError.message);
            } else {
              setToastrId('ConsentForms.concentUpdateError');
              setToastrDefaultMessage('Failed to update Consent details');
            }
          });
      } else {
        setOpen(true);
        setToastrVariable('error');
        setToastrId('ConsentForms.signatureToasterError');
        setToastrDefaultMessage('Signature/Verbal Consent is Mandatory');
        toggleLoader(false);
      }
    } else {
      setOpen(true);
      setToastrVariable('error');
      setToastrId('ConsentForms.parentNotFoundError');
      setToastrDefaultMessage(
        'No Guardian found for the client, Kindly add before you proceed',
      );
      toggleLoader(false);
    }
  };

  function getDateAfterThreeYears(date: string) {
    const parts = date.split('/');
    const month = Number.parseInt(parts[0], 10) - 1;
    const day = Number.parseInt(parts[1], 10);
    const year = Number.parseInt(parts[2], 10);
    const currentDate = new Date(year, month, day);
    const futureDate = new Date(
      currentDate.getFullYear() + 3,
      currentDate.getMonth(),
      currentDate.getDate(),
    );
    const formattedDate =
      (futureDate.getMonth() + 1).toString().padStart(2, '0') +
      '/' +
      futureDate.getDate().toString().padStart(2, '0') +
      '/' +
      futureDate.getFullYear().toString();
    return formattedDate;
  }

  const letter = `The child ${
    consentDetails.client.name
  } will turn three years on ${getDateAfterThreeYears(
    consentDetails.client.dob,
  )}, hence I am making a referral and requesting an evaluation to determine eligibility of Part B Special Education and related service from the <strong>${
    initialState.schoolName
  }</strong> School Department in signing this letter, I understand that the development information from Thom ${
    consentDetails.programDetails.name
  } will be forwarded to the <strong>${
    initialState.schoolName
  }</strong> School System Preschool Coordinator or designee.
  The developmental information shared will include the development evaluation completed by Thom ${
    consentDetails.programDetails.name
  }.
  I further agree that telephone contact between the <strong>${
    initialState.schoolName
  }</strong> School System and Thom ${
    consentDetails.programDetails.name
  } may occur to begin the transition process.`;

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const resetForm = () => {
    toggleLoader(true);
    getLEAReferral(consentIdCheck);
    setShowAlertDialog(false);
  };

  const checkFormIsSigned = () => {
    if (consentDetails.signature.length > 0) {
      return consentDetails.signature[0].rowKey !== '';
    }
    return false;
  };

  const handleDownload = (language: string) => {
    const localTimezone = dayjs.tz.guess();
    toggleLoader(true);

    downloadLeaReferral(
      consentDetails.type,
      consentDetails.consentId,
      localTimezone,
      language,
    )
      .then((response) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        // Create a Blob URL
        const blobUrl = URL.createObjectURL(blob);
        // Open the Blob URL in a new tab
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.target = '_blank';
        anchor.download = getClientDocumentFileName(
          `LEA Consent or Opt Out.pdf`,
          consentDetails.signedDate || null,
          {
            enrollmentId: consentDetails.client.dphId,
            clientName: consentDetails.client.name,
          },
        ); // Set desired file name here
        // Append anchor to document body
        document.body.appendChild(anchor);
        // Trigger anchor click
        anchor.click();
        window.open(blobUrl, '_blank');
        // Clean up after use
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(anchor);
        toggleLoader(false);
      })
      .catch((error) => {
        toggleLoader(false);
        if (isCustomError(error)) {
          const apiError = error as ApiError;
          setToastrVariable('error');
          setToastrId(apiError.id);
          setToastrDefaultMessage(apiError.message);
        } else {
          setToastrVariable('error');
          setToastrId('ConsentForms.downloadErrorMsg');
          setToastrDefaultMessage('Failed to download');
        }
      });
  };
  const onChecked = (value: boolean) => {
    if (!consentDetails) return;

    setConsentDetails((prevConsentDetails) => ({
      ...prevConsentDetails,
      refusal: value,
      revokeSignature: value ? prevConsentDetails.revokeSignature : null,
      revokedDate: value ? prevConsentDetails.revokedDate : null,
    }));
    if (!value) setRevokeGuardian(null);
    setChecked(value);
  };
  const isSignatureInProgress = () => {
    return consentDetails.signature.some((s, index) => {
      const persistedSignature = consentBackupDetails.signature[index];
      const hasSignatureData =
        s.name !== '' ||
        s.signature !== '' ||
        s.verbal ||
        s.paperConsent ||
        s.rowKey !== '' ||
        (index === 0 && contactSelected !== null);
      const wasSaved =
        persistedSignature !== undefined &&
        (!!persistedSignature.signature ||
          persistedSignature.verbal === true ||
          persistedSignature.paperConsent === true ||
          !!persistedSignature.rowKey);
      return hasSignatureData && !wasSaved;
    });
  };
  const checkedGuardianRequired = () => {
    if (
      consentDetails?.type === 'InsuranceConsent' &&
      consentDetails.consentInsurance?.isInsuranceMigrated
    ) {
      return false;
    }
    return checked;
  };
  const getContacts = async (responseContact: ConsentClientContact[]) => {
    if (responseContact) {
      const guardianList: OptionType[] = [];
      responseContact.forEach((contact) => {
        if (contact.isGuardian) {
          const prefixes = [
            contact.isPrimary && 'Primary',
            contact.isLegalGuardian && 'Legal',
          ].filter(Boolean);

          guardianList.push({
            id: contact.id.toString(),
            label: `${contact.name}${
              prefixes.length > 0 ? ` - (${prefixes.join(', ')})` : ''
            }`,
          });
        }
      });
      setGuardianContacts(guardianList);
    }
    return [];
  };
  const onRevokeConsentSignDateChange = (signedDate: string | null) => {
    const updatedRevokeSignature = consentDetails.revokeSignature
      ? { ...consentDetails.revokeSignature, consentSignedDate: signedDate }
      : consentDetails.revokeSignature;
    setConsentDetails({
      ...consentDetails,
      revokedDate: signedDate,
      revokeSignature: updatedRevokeSignature,
    });
  };
  const onRevokeSignatureVerbalConsentClick = (value: boolean) => {
    const signedDate = dayjs().utc().format(LOCAL_DATE_TIME_UTC_FORMAT);
    const formatedDate = dayjs(signedDate).format(DATE_FORMAT);
    const updatedRevokeSignature = consentDetails.revokeSignature
      ? {
          ...consentDetails.revokeSignature,
          verbal: value,
          consentSignedDate:
            consentDetails.revokeSignature.consentSignedDate || formatedDate,
        }
      : consentDetails.revokeSignature;
    if (updatedRevokeSignature) {
      setConsentDetails({
        ...consentDetails,
        revokedDate: updatedRevokeSignature.consentSignedDate,
        revokeSignature: updatedRevokeSignature,
      });
    }
  };

  const onRevokeSignaturePaperConsentClick = (value: boolean) => {
    const signedDate = dayjs().utc().format(LOCAL_DATE_TIME_UTC_FORMAT);
    const formatedDate = dayjs(signedDate).format(DATE_FORMAT);
    const updatedRevokeSignature = consentDetails.revokeSignature
      ? {
          ...consentDetails.revokeSignature,
          paperConsent: value,
          consentSignedDate:
            consentDetails.revokeSignature.consentSignedDate || formatedDate,
        }
      : consentDetails.revokeSignature;
    if (updatedRevokeSignature) {
      setConsentDetails({
        ...consentDetails,
        revokedDate: updatedRevokeSignature.consentSignedDate,
        revokeSignature: updatedRevokeSignature,
      });
    }
  };

  const onRevokeSignatureSaveClick = (sign: string) => {
    const signedDate = dayjs().utc().format(LOCAL_DATE_TIME_UTC_FORMAT);
    const formatedDate = dayjs(signedDate).format(DATE_FORMAT);
    const revokedSignature = consentDetails.revokeSignature
      ? { ...consentDetails.revokeSignature, signature: sign }
      : consentDetails.revokeSignature;

    if (revokedSignature && !revokedSignature.consentSignedDate) {
      revokedSignature.consentSignedDate = formatedDate;
    }
    if (revokedSignature) {
      setConsentDetails({
        ...consentDetails,
        revokedDate: revokedSignature.consentSignedDate ?? formatedDate,
        revokeSignature: revokedSignature,
      });
    }
  };
  const getConsentMinimumDate = (): dayjs.Dayjs | undefined => {
    const signatureWithDate = consentDetails.signature.find(
      (s) => s.consentSignedDate && s.consentSignedDate !== '',
    );
    if (signatureWithDate) {
      return dayjs(signatureWithDate.consentSignedDate);
    }
    if (consentDetails.signedDate && consentDetails.signedDate !== '') {
      return dayjs(consentDetails.signedDate);
    }
    return undefined;
  };
  const onConsentSignedDateChange = (
    consentSignedDate: string | null,
    id: number,
  ) => {
    setConsentDetails((prevConsentDetails) => {
      const updatedSignature = prevConsentDetails.signature.map(
        (item, index) => {
          if (index === id) {
            return {
              ...item,
              consentSignedDate: consentSignedDate,
            };
          }
          return item;
        },
      );

      const shouldClearRevokeDate =
        consentSignedDate &&
        prevConsentDetails.revokeSignature &&
        (!prevConsentDetails.revokeSignature.consentSignedDate ||
          dayjs(consentSignedDate).isAfter(
            dayjs(prevConsentDetails.revokeSignature.consentSignedDate),
          ));

      const updatedRevokeSignature =
        shouldClearRevokeDate && prevConsentDetails.revokeSignature
          ? { ...prevConsentDetails.revokeSignature, consentSignedDate: null }
          : prevConsentDetails.revokeSignature;

      return {
        ...prevConsentDetails,
        revokedDate: shouldClearRevokeDate
          ? null
          : prevConsentDetails.revokedDate,
        signedDate: consentSignedDate,
        signature: updatedSignature,
        revokeSignature: updatedRevokeSignature,
      };
    });
  };

  return (
    <Box component="div">
      <ModalPopup
        open={showAlertDialog}
        onCancel={() => {
          setShowAlertDialog(false);
        }}
        description="CommunicationLogTableView.deleteDescription"
        onOk={() => resetForm()}
        labelId1="Clientpage.cancelbtn"
        negativeActionLabel="cancelText"
        labelId2="Clientpage.Okbtn"
        positiveActionLabel="deleteText"
      />
      <SnackBarComponent
        open={open}
        handleClose={handleClose}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      <LanguageSelectionDialog
        open={openDownloadLanguageModal}
        onClose={() => setOpenDownloadLanguageModal(false)}
        onConfirm={(language) => {
          setOpenDownloadLanguageModal(false);
          handleDownload(language);
        }}
      />
      <TranslateWidget
        screenId={translationId.current}
        initialLanguage={'en'}
        languageChangeCallback={(lang) => {
          setSelectedLanguageValue(lang);
        }}
      >
        <Box component="main">
          <Box component="section">
            <Card className="formCardview">
              {!isOffline && (
                <Box className="flex__ justifyContent-FlexEnd">
                  <ButtonComponent
                    className="btn-primary btn-submit mb-xlg"
                    labelId="ConsentForms.listActionDownloadToolTipLabel"
                    defaultLabelId="Download"
                    variantType="contained"
                    disabled={!enableDownload}
                    onClick={() => setOpenDownloadLanguageModal(true)}
                  />
                </Box>
              )}

              <Box>
                <Box
                  style={{
                    pointerEvents:
                      hasEditPermission && isAuthorized ? 'auto' : 'none',
                    opacity:
                      hasEditPermission && isAuthorized ? 'unset' : '0.8',
                  }}
                >
                  {consentDetails.programDetails && (
                    <ProgramPanel program={consentDetails.programDetails} />
                  )}
                  <SingleLine className="width__100 mt-sm mb-sm" />
                  <Box component="div">
                    <ConsentGeneralInfo
                      consentDatePlaceholder={'ConsentForms.signedDate'}
                      consentDateDefaultPlaceholder={'Consent Date:'}
                      expiryDatePlaceholder={'ConsentForms.revokedDate'}
                      expiryDateDefaultPlaceholder={'Expiry Date:'}
                      status={handleStatus(consentDetails.status)}
                      signedDate={
                        consentDetails.signedDate
                          ? moment(consentDetails.signedDate)
                              .local()
                              .format('MM/DD/YYYY')
                          : ''
                      }
                      expiredDate={
                        expiryDate
                          ? moment(expiryDate).local().format('MM/DD/YYYY')
                          : ''
                      }
                      statusLabelId={'ConsentForms.status'}
                      statusDefaultLabelId={'Authorization Status:'}
                      expireDateView={true}
                    />
                    <SingleLine className="width__100 mt-sm mb-sm" />
                  </Box>

                  <Box component="div">
                    <ConsentClientDetails
                      titleLabel={'ConsentForms.clientTitle'}
                      defaultTitleLabel="Client Details"
                      clients={selectedClient}
                      dphIdLabel={'ConsentForms.clientDPHID'}
                      dphIddefaultLabel={'Enrollment ID:'}
                      dobLabel={'ConsentForms.clientDob'}
                      dobDefaultLabel={'Date of Birth:'}
                      genderLabel={'ConsentForms.clientGender'}
                      genderDefaultLabel={'Sex:'}
                      addressLabel={'ConsentForms.clientAddress'}
                      addressDefaultLabel={'Address:'}
                    />
                    <SingleLine className="width__100 mt-sm mb-sm" />
                  </Box>
                </Box>

                <Formik
                  initialValues={initialState}
                  validateOnMount={true}
                  innerRef={formRef}
                  enableReinitialize={true}
                  onSubmit={handleSave}
                  validationSchema={validationSchema}
                >
                  {({ setFieldValue, values, errors, touched }) => (
                    <>
                      <Box
                        component="div"
                        style={{
                          pointerEvents:
                            hasEditPermission && isAuthorized ? 'auto' : 'none',
                          opacity:
                            hasEditPermission && isAuthorized ? 'unset' : '0.8',
                        }}
                      >
                        <Box
                          component="div"
                          className="mt-md"
                          sx={{
                            pointerEvents: checkFormIsSigned()
                              ? 'none'
                              : 'auto',
                          }}
                        >
                          <MediumTypography
                            className=""
                            labelid="leaReferralConsentParentsOPTInOPTOut"
                            defaultlabel="Guardian choose to opt out of notification ?"
                          />

                          <CustomRadioButton
                            disable={!hasEditPermission || !isAuthorized}
                            data={[
                              {
                                value: 'Yes',
                                labelId: 'Yes',
                                defaultLabel: 'Yes',
                              },
                              {
                                value: 'No',
                                labelId: 'No',
                                defaultLabel: 'No',
                              },
                            ]}
                            value={
                              values.schoolNameMandatory === true ? 'No' : 'Yes'
                            }
                            onSelectItem={(value) => {
                              if (value == 'Yes') {
                                setFieldValue('schoolName', '');
                                setInitialState((prevValue) => ({
                                  ...prevValue,
                                  schoolName: '',
                                }));
                              }
                              setFieldValue(
                                'schoolNameMandatory',
                                value === 'No',
                              );
                              setInitialState((prevValue) => ({
                                ...prevValue,
                                schoolNameMandatory: value === 'No',
                              }));
                            }}
                            row={false}
                          />
                        </Box>

                        <Box component="div" className="mt-md">
                          {values.schoolNameMandatory && (
                            <Box>
                              <Textinput
                                key={'schoolName'}
                                name="schoolName"
                                labelid="School Name"
                                defaultlabelid="School Name"
                                Value={values.schoolName}
                                inputProps={{
                                  maxLength: 100,
                                  className: 'translate',
                                }}
                                sxProps={{ width: '250px' }}
                                handlechange={(text) => {
                                  setFieldValue('schoolName', text);
                                  setInitialState((prevValue) => ({
                                    ...prevValue,
                                    schoolName: text,
                                  }));
                                }}
                                Required={values.schoolNameMandatory}
                              />
                              {errors.schoolName && touched.schoolName && (
                                <MediumTypography
                                  className="errorText-md"
                                  labelid={errors.schoolName}
                                  defaultlabel="School name is required"
                                />
                              )}
                            </Box>
                          )}
                          {values.schoolNameMandatory && (
                            <Typography
                              dangerouslySetInnerHTML={{ __html: letter }}
                              sx={{
                                fontFamily: 'Lato-Regular',
                                fontSize: '14px',
                                fontWeight: 400,
                              }}
                              className="pt-md pb-md"
                            />
                          )}
                        </Box>

                        <MediumTypography
                          fontSize="18px"
                          fontweight={600}
                          textColor="#2A4241"
                          labelid={'ConsentForms.signatureTitle'}
                          defaultlabel={'Signature'}
                          className="pt-md"
                        />
                        <DropdownComponent
                          labelid="leaReferral.guardian"
                          defaultlabelid="Select Guardian*"
                          names={guardianContacts}
                          disabled={
                            !hasEditPermission ||
                            !isAuthorized ||
                            consentDetails.refusal
                          }
                          Required={checkedGuardianRequired()}
                          handleChange={(value) => {
                            if (value === '') {
                              setContactSelected(null);
                              const signatures = consentDetails.signature.map(
                                (sign: ConsentClientSignature) => ({
                                  ...sign,
                                  name: '',
                                  email: '',
                                  signature: '',
                                  verbal: false,
                                  paperConsent: false,
                                  partitionKey: '',
                                  rowKey: '',
                                  date: '',
                                  id: '',
                                  isPrimary: false,
                                  isLegalGuardian: false,
                                  isGuardian: false,
                                  relationship: '',
                                  consentSignedDate: '',
                                }),
                              );
                              setConsentDetails({
                                ...consentDetails,
                                signedDate: null,
                                signature: signatures,
                                refusal: false,
                                revokeSignature: null,
                                revokedDate: null,
                              });
                              setChecked(false);
                              setRevokeGuardian(null);
                            } else {
                              const foundContact = guardianContacts.find(
                                (contact) => contact.id === value,
                              );
                              if (foundContact) {
                                const contact = consentDetails?.contact.find(
                                  (c) => c.id.toString() === foundContact.id,
                                );
                                if (contact) {
                                  const signatures =
                                    consentDetails.signature.map(
                                      (sign: ConsentClientSignature) => ({
                                        ...sign,
                                        name: contact.name,
                                        email: contact.email,
                                        signature: '',
                                        verbal: false,
                                        paperConsent: false,
                                        partitionKey: '',
                                        rowKey: '',
                                        isPrimary: contact.isPrimary,
                                        isLegal: contact.isLegalGuardian,
                                        isGuardian: contact.isGuardian,
                                        relationship: contact.type ?? '',
                                        id: contact.id,
                                        date: moment(
                                          sign.date,
                                          'YYYY-MM-DDTHH:mm:ss',
                                        )
                                          .utc(true)
                                          .local()
                                          .format(DATE_FORMAT),
                                      }),
                                    );
                                  setConsentDetails({
                                    ...consentDetails,
                                    signature: signatures,
                                  });
                                }
                                setContactSelected(foundContact);
                              }
                            }
                          }}
                          value={contactSelected?.id || ''}
                          className="mt-md width400px"
                        />
                      </Box>

                      <ConsentSignature
                        signatureData={consentDetails.signature}
                        staffSignature={false}
                        revokeChecked={consentDetails.refusal}
                        onSaveClick={onSaveClick}
                        verbalConsentValue={consentDetails.signature}
                        paperConsentValue={consentDetails.signature}
                        onVerbalConsentClick={onVerbalConsentClick}
                        onPaperConsentClick={onPaperConsentClick}
                        defaultParentGuardianNoId="Guardian Name"
                        parentGuardianNoId="ConsentParentGuardianNoId"
                        relationshipWithChildId="ConsentRelationshipWithChild"
                        defaultRelationshipWithChildId="Guardian Type:"
                        emailId="ConsentEmail"
                        defaultEmailId="Email:"
                        isDateRequired={
                          consentDetails.signature.length > 0
                            ? consentDetails.signature[0].name !== ''
                            : false
                        }
                        viewUpdateId="ConsentViewOrUpdateSignature"
                        defaultViewUpdateId="View/update signature"
                        addSignatureId="ConsentAddSignature"
                        defaultAddSignatureId="Add Signature"
                        verbalConsentId="ConsentVerbalConsent"
                        defaultVerbalConsentId="Verbal Consent"
                        parentSignatureId="ConsentParentSignature"
                        defaultParentSignatureId="Guardian Signature"
                        isPaperConsentRequired={
                          consentDetails?.uiVersion != null &&
                          consentDetails.uiVersion > 2
                        }
                        isVerbalConsentRequired={
                          consentDetails?.uiVersion != null &&
                          consentDetails.uiVersion <= 2
                        }
                        paperConsentId="PaperConsent"
                        defaultPaperConsentId="Paper Consent"
                        onConsentSignedDateChange={onConsentSignedDateChange}
                        hasEditPermission={!hasEditPermission || !isAuthorized}
                      />
                      <SingleLine className="width__100 mt-sm mb-sm" />
                    </>
                  )}
                </Formik>

                <Box component="div">
                  <Box component="div">
                    <Box
                      style={{
                        pointerEvents:
                          consentDetails?.status === 'Revoked' ||
                          isSignatureInProgress()
                            ? 'none'
                            : 'auto',
                        opacity:
                          consentDetails?.status === 'Revoked' ||
                          isSignatureInProgress()
                            ? '0.8'
                            : 'unset',
                      }}
                    >
                      <MediumTypography
                        className="mainText-lg pt-md"
                        labelid="ConsentForms.refusalTitle"
                        defaultlabel="Understanding of Refusal"
                      />
                      <Grid
                        container
                        rowSpacing={'24px'}
                        columnSpacing={'20px'}
                      >
                        <Grid item>
                          <CheckBoxComponent
                            labelid="Consentrefusal.labelText"
                            defaultlabelid="I do not wish to give my permission"
                            ischecked={checked}
                            disabled={isSignatureInProgress() || !isAuthorized}
                            CheckHandleChange={(
                              value: React.ChangeEvent<HTMLInputElement>,
                            ) => onChecked(value.target.checked)}
                          />
                        </Grid>
                      </Grid>
                    </Box>

                    {consentDetails.refusal && (
                      <Box>
                        <DropdownComponent
                          labelid="sspReferral.contact"
                          defaultlabelid="Select Guardian"
                          names={guardianContacts}
                          disabled={
                            consentDetails?.status === 'Revoked' ||
                            !isAuthorized
                          }
                          Required={checkedGuardianRequired()}
                          handleChange={(value) => {
                            if (value === '') {
                              setRevokeGuardian(null);
                              setConsentDetails({
                                ...consentDetails,
                                revokeSignature: null,
                              });
                            } else {
                              const foundContact = guardianContacts.find(
                                (contact) => contact.id === value,
                              );
                              if (foundContact) {
                                const contact = consentDetails?.contact.find(
                                  (c) => c.id.toString() === foundContact.id,
                                );
                                if (contact) {
                                  setConsentDetails({
                                    ...consentDetails,
                                    revokeSignature: {
                                      name: contact.name,
                                      email: contact.email,
                                      signature: '',
                                      verbal: false,
                                      paperConsent: false,
                                      partitionKey: '',
                                      rowKey: '',
                                      isPrimary: contact.isPrimary,
                                      relationship: contact.type ?? '',
                                      id: contact.id,
                                      isLegal: contact.isLegalGuardian,
                                      isGuardian: contact.isGuardian,
                                    },
                                  });
                                }
                                setRevokeGuardian(foundContact);
                              }
                            }
                          }}
                          value={revokeGuardian?.id || ''}
                          className="mt-md width400px"
                        />

                        <ConsentSignature
                          signatureData={
                            consentDetails.revokeSignature
                              ? [
                                  {
                                    ...consentDetails.revokeSignature,
                                  },
                                ]
                              : []
                          }
                          minDate={getConsentMinimumDate()}
                          staffSignature={false}
                          revokeChecked={consentDetails.refusal}
                          onSaveClick={onRevokeSignatureSaveClick}
                          verbalConsentValue={[
                            {
                              verbal:
                                consentDetails.revokeSignature?.verbal || false,
                            },
                          ]}
                          paperConsentValue={[
                            {
                              paperConsent:
                                consentDetails.revokeSignature?.paperConsent ||
                                false,
                            },
                          ]}
                          onVerbalConsentClick={
                            onRevokeSignatureVerbalConsentClick
                          }
                          onPaperConsentClick={
                            onRevokeSignaturePaperConsentClick
                          }
                          defaultParentGuardianNoId="Guardian Name"
                          parentGuardianNoId="ConsentParentGuardianNoId"
                          relationshipWithChildId="ConsentRelationshipWithChild"
                          defaultRelationshipWithChildId="Guardian Type:"
                          emailId="ConsentEmail"
                          defaultEmailId="Email:"
                          isDateRequired={consentDetails.refusal}
                          viewUpdateId="ConsentViewOrUpdateSignature"
                          defaultViewUpdateId="View/update signature"
                          addSignatureId="ConsentAddSignature"
                          defaultAddSignatureId="Add Signature"
                          verbalConsentId="ConsentVerbalConsent"
                          defaultVerbalConsentId="Verbal Consent"
                          parentSignatureId="ConsentParentSignature"
                          defaultParentSignatureId="Guardian Signature"
                          isPaperConsentRequired={
                            consentDetails?.uiVersion != null &&
                            consentDetails.uiVersion > 2
                          }
                          isVerbalConsentRequired={
                            consentDetails?.uiVersion != null &&
                            consentDetails.uiVersion <= 2
                          }
                          paperConsentId="PaperConsent"
                          defaultPaperConsentId="Paper Consent"
                          onConsentSignedDateChange={
                            onRevokeConsentSignDateChange
                          }
                          hasEditPermission={
                            consentDetails?.status === 'Revoked' ||
                            !isAuthorized
                          }
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
                <Box component="div">
                  <Typography
                    dangerouslySetInnerHTML={{ __html: disclaimer }}
                    sx={{
                      fontFamily: 'Lato-Regular',
                      fontSize: '14px',
                      fontWeight: 400,
                    }}
                  />
                </Box>
              </Box>
            </Card>
            {isAuthorized && (
              <Box className="p-lg pr-none justifyContent-FlexEnd flex__">
                <ButtonComponent
                  className="btn-primary btn-cancel mr-md"
                  sxProps={{
                    display:
                      hasEditPermission ||
                      (consentDetails?.status !== 'Revoked' &&
                        consentDetails.refusal)
                        ? 'auto'
                        : 'none',
                  }}
                  labelId={btnName ? 'ConsentBack' : 'ConsentCancel'}
                  defaultLabelId="Cancel"
                  variantType="outlined"
                  onClick={handleClear}
                />
                <ButtonComponent
                  className="btn-primary btn-submit"
                  labelId="ConsentSave"
                  defaultLabelId="Save"
                  variantType="contained"
                  sxProps={{
                    display:
                      hasEditPermission ||
                      (consentDetails?.status !== 'Revoked' &&
                        consentDetails.refusal)
                        ? 'auto'
                        : 'none',
                  }}
                  onClick={formRef.current?.handleSubmit}
                />
              </Box>
            )}
          </Box>
        </Box>
      </TranslateWidget>
    </Box>
  );
};

export default LEAReferralConsent;
